import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './Reliability.css';
import { statusToTheme } from './utils';
import { List } from './inner/List';
import { Item } from './inner/Item';
import { Header } from './inner/Header';
import { HeaderMobile } from './inner/HeaderMobile';
import { TReliabilityType, IReliableParams } from '../../types/developerV2/reliability';
import { Responsive, UIHeading2 } from '@cian/ui-kit';

export interface IReliabilityDesktopProps {
  status: TReliabilityType;
  title: string;
  description?: string | null;
  details: IReliableParams[];
}

export const Reliability: React.FC<IReliabilityDesktopProps> = props => (
  <div className={clsx(styles['container'], styles[statusToTheme(props.status)])}>
    <Responsive desktop>
      <div className={styles['header']}>
        <Header title={props.title} description={props.description} />
      </div>
    </Responsive>
    <Responsive phone tablet>
      <div className={styles['section--header']}>
        <UIHeading2>Надёжность застройщика</UIHeading2>
      </div>
      <HeaderMobile title={props.title} description={props.description} status={props.status} />
    </Responsive>
    <div className={styles['main']}>
      <List>
        {props.details.map((item, index) => (
          <Item key={index} iconType={item.type} label={item.subtitle} title={item.title} />
        ))}
      </List>
    </div>
  </div>
);
